import React from 'react';

import { Flex, Skeleton, SkeletonText, Stack } from '@chakra-ui/react';

import style from './styles/CalculatorSideBlock.style';

const CalculatorsideBlock = () => {
  return (
    <Stack sx={style.root}>
      <CalculatorSingleBlock data-testid="CalculatorSingleBlock" />
      <Skeleton className="sideBlockSkeleton" />
      <CalculatorSingleBlock data-testid="CalculatorSingleBlock" />
    </Stack>
  );
};
const CalculatorSingleBlock = () => {
  return (
    <>
      <SkeletonText
        skeletonHeight={'24px'}
        className="singleBlockSkeletonText1"
      />
      <SkeletonText
        skeletonHeight={'16px'}
        className="singleBlockSkeletonText2"
      />
      <CalculatorOption />
      <CalculatorOption />
      <CalculatorOption />
    </>
  );
};
const CalculatorOption = () => {
  return (
    <Flex className="optionContainer">
      <Skeleton className="optionSkeleton" />
      <SkeletonText className="optionSkeletonText" skeletonHeight={'16px'} />
    </Flex>
  );
};

export default CalculatorsideBlock;
